
import { Component, Vue } from "vue-property-decorator";
import { Center, Entity, iniRawCenter, iniRawEntity } from "@/entities";
import Pageable from "@/entities/pageable/pageable_collection";
import { Breadcrum } from "@/components/commons";
import { iniServicePointPageFilter, IServicePointPageFilter, SearchEntitiesRequest } from "@/services";
import ServicePointTabs from "@/components/servicePoints/servicePoint-tabs/ServicePointTabs.vue";
import ServicePointGrid from "@/components/servicePoints/servicePoint-grid/ServicePointGrid.vue";
import { ServicePointFilters, ServicePointHeader } from "@/components/servicePoints";
import LinkHidden from "@/components/commons/link-hidden/LinkHidden.vue";

@Component({
  components: {
    ServicePointHeader,
    Breadcrum,
    ServicePointTabs,
    ServicePointGrid,
    ServicePointFilters,
    LinkHidden,
  },
})
export class ServicePointPage extends Vue {
  filters: IServicePointPageFilter = { ...iniServicePointPageFilter };
  breadcrum: string[] = [this.$t("centerPage.breadcrum") as string];
  paths: string[] = ["/entities"];
  centerId!: string;
  entityId!: string;
  entityActive!: boolean;
  centerActive!: boolean;
  center: Center = new Center({ ...iniRawCenter });
  entity: Entity = new Entity({ ...iniRawEntity });
  loaded = false;
  countResults: { centers: number } = {
    centers: 0,
  };

  created(): void {
    this.entityId = this.$route.params.id;
    this.entityActive = this.$route.query.entityActive !== undefined ? this.$route.query.entityActive === "true" : true;
    this.centerActive = this.$route.query.centerActive !== undefined ? this.$route.query.centerActive === "true" : true;

    this.fetchEntity();
    this.centerId = this.$route.params.idCenter;

    // Building the breadcrumb path with query parameters
    const centerPagePath = "/entity/" + this.$route.params.id + "/centers/";
    const queryParams = new URLSearchParams();
    if (this.$route.query.entityActive !== undefined) {
      queryParams.append('entityActive', this.$route.query.entityActive as string);
    }

    const fullCenterPath = queryParams.toString() ?
      centerPagePath + "?" + queryParams.toString() :
      centerPagePath;

    this.paths.push(fullCenterPath);
  }

  handleRefresh(payload?: { created?: boolean }) {
    const grid = this.$refs.servicePointsGrid as any;
    grid.fetchServicePoints(payload);

  }
  fetchEntity(): void {
    const requestParams: SearchEntitiesRequest = {
      aggregateId: this.entityId,
      limit: 100,
      offset: 0,
      sortField: "aggregateId",
      sortWay: "DESC",
      active: this.entityActive,
    };
    this.$services.entity
      .fetchEntitiesV2(requestParams)
      .then((response: Pageable<Entity>) => {
        if (response.results.length == 1) {
          this.entity = response.results[0];
          this.breadcrum.push(this.entity.name);
          this.fetchCenter();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchCenter(): void {
    const query: Record<string, unknown> = {};
    query["limit"] = 1;
    query["offset"] = 0;
    query["aggregateId"] = this.centerId;
    query["sortField"] = "centerName";
    query["sortWay"] = "ASC";
    query["active"] = this.centerActive;
    this.$services.center
      .fetchCentersV2(query)
      .then((response: Pageable<Center>) => {
        if (response.results.length == 1) {
          this.center = response.results[0];
          this.breadcrum.push(this.center.name!);
          this.loaded = true;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

export default ServicePointPage;
